import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { API_BASE } from './apiConfig';
import { Helmet } from 'react-helmet';

const About = () => {
    const { t } = useTranslation();
    const [aboutData, setAboutData] = useState({ title: '', content: '' });
    const [loading, setLoading] = useState(true);

    const goldColor = '#c5a059';

    useEffect(() => {
        window.scrollTo(0, 0);
        fetch(`${API_BASE}/api/about`)
            .then(res => res.json())
            .then(data => {
                setAboutData(data);
                setLoading(false);
            })
            .catch(err => {
                console.error("Error fetching about data:", err);
                setLoading(false);
            });
    }, []);

    // Վստահության թվերը (Կարող ես փոխել)
    const stats = [
        { label: 'Տարվա փորձ', value: '5+' },
        { label: 'Պատվերներ', value: '10,000+' },
        { label: 'Մեքենաներ', value: '15+' },
        { label: 'Սպասարկում', value: '24/7' }
    ];

    return (
        <div style={containerStyle}>
            <Helmet>
                <title>{t('about_us')} | Liber Group - Արմեն Հովսեփյան</title>
                <meta name="description" content="Liber Group-ի պատմությունը և առաքելությունը: Հիմնադիր՝ Արմեն Հովսեփյան: Պրոֆեսիոնալ լոգիստիկա և բեռնափոխադրում Հայաստանում:" />
                <link rel="canonical" href="https://liber.am/about" />
            </Helmet>

            <div style={cardStyle}>
                <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                    <h1 style={titleStyle}>{aboutData.title || t('about_us')}</h1>
                    <div style={underlineStyle}></div>
                </div>
                
                {loading ? (
                    <div style={loaderContainer}>
                        <div className="custom-loader"></div>
                        <p style={{ color: '#94a3b8', marginTop: '15px' }}>{t('loading')}</p>
                    </div>
                ) : (
                    <div style={contentWrapper}>
                        <div style={textStyle}>
                            {aboutData.content || t('no_info_added')}
                        </div>

                        {/* --- Ավելացված է՝ Վստահության թվեր --- */}
                        <div style={statsGridStyle}>
                            {stats.map((stat, index) => (
                                <div key={index} style={statItemStyle}>
                                    <div style={{ color: goldColor, fontSize: '24px', fontWeight: '800' }}>{stat.value}</div>
                                    <div style={{ color: '#64748b', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '1px' }}>{stat.label}</div>
                                </div>
                            ))}
                        </div>

                        {/* --- Ավելացված է՝ Հեղինակային բլոկ --- */}
                        <div style={authorBlockStyle}>
                            <p style={{ margin: 0, fontStyle: 'italic', color: '#475569' }}>
                                "Մեր նպատակն է սահմանել որակի նոր չափանիշներ հայաստանյան բեռնափոխադրման շուկայում:"
                            </p>
                            <h4 style={{ margin: '10px 0 0', color: '#0f172a' }}>Արմեն Հովսեփյան</h4>
                            <span style={{ fontSize: '13px', color: goldColor }}>Հիմնադիր տնօրեն</span>
                        </div>
                    </div>
                )}
            </div>

            <style>{`
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(20px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                .custom-loader {
                    width: 40px; height: 40px;
                    border: 3px solid rgba(197, 160, 89, 0.1);
                    border-radius: 50%;
                    border-top-color: ${goldColor};
                    animation: spin 1s ease-in-out infinite;
                    margin: 0 auto;
                }
                @keyframes spin { to { transform: rotate(360deg); } }
            `}</style>
        </div>
    );
};

// --- Նոր Style-ներ ---

const statsGridStyle = {
    display: 'grid',
    gridTemplateColumns: window.innerWidth <= 768 ? '1fr 1fr' : '1fr 1fr 1fr 1fr',
    gap: '20px',
    marginTop: '40px',
    padding: '30px 0',
    borderTop: '1px solid #e2e8f0',
    borderBottom: '1px solid #e2e8f0',
    textAlign: 'center'
};

const statItemStyle = {
    padding: '10px'
};

const authorBlockStyle = {
    marginTop: '40px',
    padding: '25px',
    background: '#fcfaf2',
    borderRadius: '20px',
    borderLeft: '5px solid #c5a059',
    textAlign: 'left'
};

// ... Մնացած հին Style-ները (containerStyle, cardStyle և այլն) թող մնան նույնը

const containerStyle = { padding: '160px 5% 100px', minHeight: '90vh', background: '#f8fafc', display: 'flex', justifyContent: 'center' };
const cardStyle = { maxWidth: '900px', width: '100%', background: '#fff', padding: window.innerWidth <= 768 ? '40px 25px' : '70px 60px', borderRadius: '30px', boxShadow: '0 20px 40px rgba(0,0,0,0.05)', border: '1px solid rgba(197, 160, 89, 0.1)', animation: 'fadeIn 0.8s ease-out' };
const titleStyle = { color: '#0f172a', fontSize: window.innerWidth <= 768 ? '28px' : '38px', fontWeight: '800', marginBottom: '15px', letterSpacing: '-0.5px' };
const underlineStyle = { width: '60px', height: '4px', background: '#c5a059', margin: '0 auto', borderRadius: '2px' };
const contentWrapper = { position: 'relative' };
const textStyle = { 
    lineHeight: '1.6', // Մի փոքր փոքրացրու, որ շատ չձգվի
    color: '#334155', 
    fontSize: window.innerWidth <= 768 ? '15px' : '17px', // Մոբայլում 15px, դեսկտոպում 17px
    whiteSpace: 'pre-line', 
    textAlign: 'left', // 'justify'-ի փոխարեն դիր 'left'
    fontFamily: "'Inter', sans-serif",
    wordBreak: 'break-word' 
};
const loaderContainer = { textAlign: 'center', padding: '50px 0' };

export default About;